import { useApiQuery } from './useApiQuery';
import { dashboardApi } from '../lib/api/dashboard';
import type { DashboardSummary } from '@overlayqa/shared';
import { log } from '@/lib/logger';

log.info('[useDashboardSummary] Module loaded');

export function useDashboardSummary() {
  log.info('[useDashboardSummary] hook called');

  return useApiQuery<DashboardSummary>({
    queryKey: ['dashboard-summary'],
    queryFn: (token) => dashboardApi.summary(token),
    staleTime: 60_000,
  });
}
